export default __webpack_public_path__ + "static/media/homepage-line.fab40fba.svg";